import FilterCircleFilledIcon from './FilterCircleFilledIcon';

export default FilterCircleFilledIcon;
